import React from 'react';
import useReveal from '../hooks/useReveal';
import PageBanner from '../Components/PageBanner';
import AboutSection from '../Components/AboutSection';
import AboutPrinciples from '../Components/AboutPrinciples';
import HProficiency from '../Components/HProficiency';
import DeveloperStrip from '../Components/DeveloperStrip';

const About = () => {
    useReveal();

    return (
        <div>
            <PageBanner
                title="About"
                text="Glass, aluminium and UPVC facade work from Ghaziabad."
                image="/projects/4/2.jpeg"
            />
            <AboutSection />
            <AboutPrinciples />
            <DeveloperStrip />
            <HProficiency />
        </div>
    );
};

export default About;
